// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"2":"blogPost","239":"blog","443":"about","631":"contact"}[chunkId] || chunkId) + "." + {"2":"0d8c88d2","239":"7dc2941e","443":"cc5808c5","631":"a02495c2","897":"4a35e5cc"}[chunkId] + ".js";
};